module.exports = __webpack_public_path__ + "img/tarot-major-arcana-21.e493b09a.png";